export { default } from './InstructionsForUse';



// WEBPACK FOOTER //
// ./src/components/Help/InstructionsForUse/index.ts